const database = [
  {
    internalName: "DEFENSEGRIDTHEAWAKENING",
    title: "Defense Grid: The Awakening",
    metacriticLink: "/game/pc/defense-grid-the-awakening",
    dealID: "4QKKiqa4JZSa6tCrCvsWIJ2zInGs1olsf9skKT92p4k%3D",
    storeID: "25",
    gameID: "402",
    salePrice: "0.00",
    normalPrice: "9.99",
    isOnSale: "1",
    savings: "100.000000",
    metacriticScore: "81",
    steamRatingText: "Overwhelmingly Positive",
    steamRatingPercent: "96",
    steamRatingCount: "3356",
    steamAppID: "18500",
    releaseDate: 1228694400,
    lastChange: 1608481569,
    dealRating: "10.0",
    thumb:
      "https://cdn.cloudflare.steamstatic.com/steam/apps/18500/capsule_sm_120.jpg?t=1572394805",
  },
  {
    internalName: "DAEDALICGIGANTICBUNDLE",
    title: "Daedalic - Gigantic Bundle",
    metacriticLink: null,
    dealID: "RezOhXEmmzsCqTlyVYkecLHXolE67xLESnKGrUJdYz0%3D",
    storeID: "2",
    gameID: "147281",
    salePrice: "13.00",
    normalPrice: "129.99",
    isOnSale: "1",
    savings: "89.999231",
    metacriticScore: "0",
    steamRatingText: "Mostly Positive",
    steamRatingPercent: "75",
    steamRatingCount: "13240",
    steamAppID: "76471",
    releaseDate: 0,
    lastChange: 1608509952,
    dealRating: "10.0",
    thumb:
      "https://cdn.cloudflare.steamstatic.com/steam/subs/76471/capsule_sm_120.jpg?t=1481563053",
  },
  {
    internalName: "HITMAN2GOLDEDITION",
    title: "HITMAN 2 Gold Edition",
    metacriticLink: null,
    dealID: "1ecjIcsBbaNUwWwn09KjdffFaM051GmjD1Sxs942YjQ%3D",
    storeID: "3",
    gameID: "188236",
    salePrice: "12.30",
    normalPrice: "99.99",
    isOnSale: "1",
    savings: "87.698770",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608512122,
    dealRating: "10.0",
    thumb:
      "https://images.greenmangaming.com/2892f48069c34d40af4e4744e0e64b54/82c7f3e1668944fcb94675297f3d12ce.jpg",
  },
  {
    internalName: "ONEPIECEBURNINGBLOODGOLDEDITION",
    title: "ONE PIECE BURNING BLOOD GOLD EDITION",
    metacriticLink: "/game/pc/one-piece-burning-blood---gold-edition",
    dealID: "IZE0Ktezh1S5r0%2BqSsR5WLWa1iGWK1%2ByLqV5ThFmzUM%3D",
    storeID: "23",
    gameID: "157072",
    salePrice: "10.29",
    normalPrice: "74.99",
    isOnSale: "1",
    savings: "86.278170",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 1472688000,
    lastChange: 1608510463,
    dealRating: "10.0",
    thumb:
      "https://images.greenmangaming.com/de83e6c99ef148b0898d89d8a0fda891/a5ae44bb964b4b028145f590bcd5eab7.jpg",
  },
  {
    internalName: "NINOKUNIIIREVENANTKINGDOMTHEPRINCESEDITION",
    title: "Ni no Kuni II: Revenant Kingdom - The Prince's Edition",
    metacriticLink: null,
    dealID: "MqFZ0wHuNArA98%2BaUieiIsj2G6vWE3xVzK8HPAzU9sg%3D",
    storeID: "3",
    gameID: "171780",
    salePrice: "10.75",
    normalPrice: "79.98",
    isOnSale: "1",
    savings: "86.559140",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608305969,
    dealRating: "10.0",
    thumb:
      "https://images.greenmangaming.com/42b323a5cc0f4aa1899364b0e501ebd0/e5791e804a894158a81e6e8f772ad0e3.jpg",
  },
  {
    internalName: "FARCRY5GOLDEDITION",
    title: "Far Cry 5 Gold Edition",
    metacriticLink: null,
    dealID: "z%2FRdQPTtVs2GCH4f76UewjtFWAEA%2Fums9iOB6liRLjU%3D",
    storeID: "23",
    gameID: "169242",
    salePrice: "15.82",
    normalPrice: "89.99",
    isOnSale: "1",
    savings: "82.420269",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608510528,
    dealRating: "10.0",
    thumb:
      "https://gamersgatep.imgix.net/f/9/6/3b855d00073bc3cb91510918e36d4cb865ede69f.jpg?auto=format",
  },
  {
    internalName: "FARCRY5GOLDEDITION",
    title: "Far Cry 5 Gold Edition",
    metacriticLink: null,
    dealID: "ETRmWHPLOquONHXWJ3l5hayFVs0h7C7nWOuMRakX%2B8w%3D",
    storeID: "2",
    gameID: "169242",
    salePrice: "16.38",
    normalPrice: "89.99",
    isOnSale: "1",
    savings: "81.797978",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608523138,
    dealRating: "10.0",
    thumb:
      "https://gamersgatep.imgix.net/f/9/6/3b855d00073bc3cb91510918e36d4cb865ede69f.jpg?auto=format",
  },
  {
    internalName: "THECREW2GOLDEDITION",
    title: "The Crew 2 Gold Edition",
    metacriticLink: null,
    dealID: "KO0A7f4FTs78S2To3ST2%2BHFEUad5y8CSJvNoiOw0gGE%3D",
    storeID: "2",
    gameID: "172258",
    salePrice: "16.38",
    normalPrice: "89.99",
    isOnSale: "1",
    savings: "81.797978",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608526950,
    dealRating: "10.0",
    thumb:
      "https://gamersgatep.imgix.net/0/3/c/b734b944a496465c1418880b8b2bd024d3762c30.jpg?auto=format",
  },
  {
    internalName: "THECREW2GOLDEDITION",
    title: "The Crew 2 Gold Edition",
    metacriticLink: null,
    dealID: "KGW%2Fl%2BPKd4XFOrQwM1Covr1LYHv4XeP1vqTM8D0pq8M%3D",
    storeID: "23",
    gameID: "172258",
    salePrice: "17.58",
    normalPrice: "99.99",
    isOnSale: "1",
    savings: "82.418242",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608510583,
    dealRating: "10.0",
    thumb:
      "https://gamersgatep.imgix.net/0/3/c/b734b944a496465c1418880b8b2bd024d3762c30.jpg?auto=format",
  },
  {
    internalName: "ASSASSINSCREEDORIGINSGOLDEDITION",
    title: "Assassins Creed Origins Gold Edition",
    metacriticLink: null,
    dealID: "XneYYKAieKNf38GxZ56b2LgyiRQ0l4pn1o1%2BCcvsnC0%3D",
    storeID: "23",
    gameID: "170045",
    salePrice: "17.58",
    normalPrice: "99.99",
    isOnSale: "1",
    savings: "82.418242",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608510583,
    dealRating: "10.0",
    thumb:
      "https://gamersgatep.imgix.net/2/3/c/2aeaefcbb2d1810fa0fae3ffa0eec9cbf4a46c32.jpg?auto=format",
  },
  {
    internalName: "WATCHDOGS2GOLDEDITION",
    title: "Watch_Dogs 2 Gold Edition",
    metacriticLink: null,
    dealID: "k7n68eleUueue2W%2F0FhvVpythFGFntdm703ASVebWQE%3D",
    storeID: "23",
    gameID: "153679",
    salePrice: "17.58",
    normalPrice: "99.99",
    isOnSale: "1",
    savings: "82.418242",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608510583,
    dealRating: "10.0",
    thumb:
      "https://gamersgatep.imgix.net/f/1/0/12669512cefc57a3273f7e92959f71b4e060b01f.jpg?auto=format",
  },
  {
    internalName: "FARCRY5ANDFARCRYNEWDAWNDELUXEEDITIONBUNDLECOMPLETEEDITION",
    title:
      "Far Cry 5 and Far Cry New Dawn Deluxe Edition Bundle (Complete Edition)",
    metacriticLink: null,
    dealID: "QDmsK%2BmiTJm5LcRDGRCdUvEdEdLaNqMPyxsdeRsoVwE%3D",
    storeID: "23",
    gameID: "198564",
    salePrice: "17.58",
    normalPrice: "99.99",
    isOnSale: "1",
    savings: "82.418242",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608510584,
    dealRating: "10.0",
    thumb:
      "https://gamersgatep.imgix.net/e/1/5/8ae16486c3eadf6aaf1bf5ecaee507e05963d51e.jpg?auto=format",
  },
  {
    internalName: "ASSASSINSCREEDORIGINSGOLDEDITION",
    title: "Assassins Creed Origins Gold Edition",
    metacriticLink: null,
    dealID: "56PpgOF0PtBJh2MOY4HjK8drDI4%2BlXYKlfS7EuVozfY%3D",
    storeID: "2",
    gameID: "170045",
    salePrice: "18.20",
    normalPrice: "99.99",
    isOnSale: "1",
    savings: "81.798180",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608522824,
    dealRating: "10.0",
    thumb:
      "https://gamersgatep.imgix.net/2/3/c/2aeaefcbb2d1810fa0fae3ffa0eec9cbf4a46c32.jpg?auto=format",
  },
  {
    internalName: "FARCRY5ANDFARCRYNEWDAWNDELUXEEDITIONBUNDLECOMPLETEEDITION",
    title:
      "Far Cry 5 and Far Cry New Dawn Deluxe Edition Bundle (Complete Edition)",
    metacriticLink: null,
    dealID: "XKrMha61VF4Jz9t3DGXyxU4hcJ2M%2Farun28S%2F4ugXjY%3D",
    storeID: "2",
    gameID: "198564",
    salePrice: "18.20",
    normalPrice: "99.99",
    isOnSale: "1",
    savings: "81.798180",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608523139,
    dealRating: "10.0",
    thumb:
      "https://gamersgatep.imgix.net/e/1/5/8ae16486c3eadf6aaf1bf5ecaee507e05963d51e.jpg?auto=format",
  },
  {
    internalName: "NINOKUNIIIREVENANTKINGDOMTHEPRINCESEDITION",
    title: "Ni no Kuni II: Revenant Kingdom - The Prince's Edition",
    metacriticLink: null,
    dealID: "UisNZi6Q2lZ%2FjNE3URw5a%2FA2Wd2hMgQ%2FOTjGpDYXaEY%3D",
    storeID: "21",
    gameID: "171780",
    salePrice: "12.79",
    normalPrice: "79.98",
    isOnSale: "1",
    savings: "84.008502",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608334227,
    dealRating: "10.0",
    thumb:
      "https://images.greenmangaming.com/42b323a5cc0f4aa1899364b0e501ebd0/e5791e804a894158a81e6e8f772ad0e3.jpg",
  },
  {
    internalName: "ONEPIECEBURNINGBLOODGOLDEDITION",
    title: "ONE PIECE BURNING BLOOD GOLD EDITION",
    metacriticLink: "/game/pc/one-piece-burning-blood---gold-edition",
    dealID: "imUjRkiL%2FBVvcPz9FpDgZIjjxbXXkCr0G15Wmo0KbA0%3D",
    storeID: "3",
    gameID: "157072",
    salePrice: "10.32",
    normalPrice: "74.98",
    isOnSale: "1",
    savings: "86.236330",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 1472688000,
    lastChange: 1608082187,
    dealRating: "10.0",
    thumb:
      "https://images.greenmangaming.com/de83e6c99ef148b0898d89d8a0fda891/a5ae44bb964b4b028145f590bcd5eab7.jpg",
  },
  {
    internalName: "NARUTOTOBORUTOSHINOBISTRIKERDELUXEEDITION",
    title: "Naruto to Boruto Shinobi Striker - Deluxe Edition",
    metacriticLink: null,
    dealID: "n11LTBnmu3ZXKhG%2BIwFGocXhOzw7ZRatacoSI5wSLUk%3D",
    storeID: "3",
    gameID: "189692",
    salePrice: "11.01",
    normalPrice: "79.98",
    isOnSale: "1",
    savings: "86.234059",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608082273,
    dealRating: "10.0",
    thumb:
      "https://images.greenmangaming.com/bea8652cdc044930bc603ea6e843b0bb/1d7901df5b8843c2965b9b97f3361afc.jpg",
  },
  {
    internalName: "PROJECTCARS2DELUXEEDITION",
    title: "Project CARS 2 - Deluxe Edition",
    metacriticLink: null,
    dealID: "bODL8zcog%2FqBymHd3XH1s61Lxxp%2B%2FnTZzmbpnHs3NzI%3D",
    storeID: "21",
    gameID: "170776",
    salePrice: "14.39",
    normalPrice: "89.99",
    isOnSale: "1",
    savings: "84.009334",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608334185,
    dealRating: "10.0",
    thumb:
      "https://images.greenmangaming.com/db350afbcffc40cba712e1886196063a/513986ddb169414fa20aefabfd4d5657.jpg",
  },
  {
    internalName: "PROJECTCARS2DELUXEEDITION",
    title: "Project CARS 2 - Deluxe Edition",
    metacriticLink: null,
    dealID: "Tf%2FMrE7pIjicmTAH4YWveUgYLcUrmeA3ftjgCI9iykg%3D",
    storeID: "3",
    gameID: "170776",
    salePrice: "12.38",
    normalPrice: "89.99",
    isOnSale: "1",
    savings: "86.242916",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608082022,
    dealRating: "10.0",
    thumb:
      "https://images.greenmangaming.com/db350afbcffc40cba712e1886196063a/513986ddb169414fa20aefabfd4d5657.jpg",
  },
  {
    internalName: "DRAGONBALLFIGHTERZFIGHTERZEDITION",
    title: "Dragon Ball Fighter Z  FighterZ Edition",
    metacriticLink: null,
    dealID: "7Ht2NUR%2BxILO3kCJMd4cq16op%2FZVNSnH3%2FeboCT6pl0%3D",
    storeID: "3",
    gameID: "174472",
    salePrice: "13.07",
    normalPrice: "94.98",
    isOnSale: "1",
    savings: "86.239208",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608080808,
    dealRating: "10.0",
    thumb:
      "https://images.greenmangaming.com/1aaa5e509b074fd7a2a0df69f2983401/9920f9cf5bc84897995fdc70f9f79ed1.jpg",
  },
  {
    internalName:
      "FARCRY5GOLDEDITIONANDFARCRYNEWDAWNDELUXEEDITIONBUNDLEULTIMATEEDITION",
    title:
      "Far Cry 5 Gold Edition and Far Cry  New Dawn Deluxe Edition Bundle (Ultimate Edition)",
    metacriticLink: null,
    dealID: "N4ZnVx4Rx7xKScUZbIvlp5FOEbYS1HPpaXRxs%2BTEWSc%3D",
    storeID: "23",
    gameID: "203348",
    salePrice: "22.86",
    normalPrice: "129.99",
    isOnSale: "1",
    savings: "82.414032",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608510626,
    dealRating: "10.0",
    thumb:
      "https://gamersgatep.imgix.net/6/5/b/7831205083de19ac64ca6b6d7a3762bb27c1cb56.jpg?auto=format",
  },
  {
    internalName: "SIDMEIERSCIVILIZATIONVIDIGITALDELUXEEDITION",
    title: "Sid Meiers Civilization VI Digital Deluxe Edition",
    metacriticLink: null,
    dealID: "9%2B8eaF0R1W%2BRxzXx%2B%2BgfrBekaR4vhtRQzCiKPr32D5o%3D",
    storeID: "23",
    gameID: "154951",
    salePrice: "17.15",
    normalPrice: "79.99",
    isOnSale: "1",
    savings: "78.559820",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608510577,
    dealRating: "10.0",
    thumb:
      "https://gamersgatep.imgix.net/9/d/1/f67bbe63d1cba1a2a7ce4bc34c48bba5f4b541d9.jpg?auto=format",
  },
  {
    internalName: "MOVAVIPHOTOBUNDLE",
    title: "Movavi Photo Bundle",
    metacriticLink: null,
    dealID: "b7MzSSA1d2%2BL5lm3LK9%2BCayZmR9r0Ii5%2BKfei7QC4po%3D",
    storeID: "3",
    gameID: "223357",
    salePrice: "14.94",
    normalPrice: "84.90",
    isOnSale: "1",
    savings: "82.402827",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608252267,
    dealRating: "10.0",
    thumb:
      "https://images.greenmangaming.com/de4bf10a89a2418ca73aa1b705c2bcfa/e85fe684c87c436c8e48aa415f2ce73c.jpg",
  },
  {
    internalName:
      "FARCRY5GOLDEDITIONANDFARCRYNEWDAWNDELUXEEDITIONBUNDLEULTIMATEEDITION",
    title:
      "Far Cry 5 Gold Edition and Far Cry  New Dawn Deluxe Edition Bundle (Ultimate Edition)",
    metacriticLink: null,
    dealID: "XD6zDFx2O94yzcI3wZ%2Bcs4sofbTzszXddLDGe82T6K4%3D",
    storeID: "2",
    gameID: "203348",
    salePrice: "23.66",
    normalPrice: "129.99",
    isOnSale: "1",
    savings: "81.798600",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608523139,
    dealRating: "10.0",
    thumb:
      "https://gamersgatep.imgix.net/6/5/b/7831205083de19ac64ca6b6d7a3762bb27c1cb56.jpg?auto=format",
  },
  {
    internalName: "DRAGONBALLFIGHTERZULTIMATEEDITION",
    title: "Dragon Ball Fighter Z  Ultimate Edition",
    metacriticLink: null,
    dealID: "Fm8%2FTqbp8VIRKMAMNNf6WpsXT0Z7Xv3LEwS%2Fg82szlc%3D",
    storeID: "3",
    gameID: "174473",
    salePrice: "15.13",
    normalPrice: "109.97",
    isOnSale: "1",
    savings: "86.241702",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608081143,
    dealRating: "10.0",
    thumb:
      "https://images.greenmangaming.com/33077208537a4624aa4550a636a58517/3085b7d47d2f4eba942b258ed90503fa.jpg",
  },
  {
    internalName: "STARLINKBATTLEFORATLASDELUXEEDITION",
    title: "Starlink: Battle for Atlas - Deluxe Edition",
    metacriticLink: null,
    dealID: "FzcymYxpjWFSR6XXUXlUYhp1XkeO6oSv3OuW%2B1d3nyg%3D",
    storeID: "23",
    gameID: "200999",
    salePrice: "17.58",
    normalPrice: "79.99",
    isOnSale: "1",
    savings: "78.022253",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608510584,
    dealRating: "10.0",
    thumb:
      "https://gamersgatep.imgix.net/f/e/6/0faf480ba1b12ebf337cd80481fd459d234aa6ef.jpg?auto=format",
  },
  {
    internalName: "ASSASSINSCREEDODYSSEYDELUXEEDITION",
    title: "Assassin's Creed Odyssey - Deluxe Edition",
    metacriticLink: null,
    dealID: "O9lqMshIkM0k7T%2FXbQd%2BZ3ZWEK3IPfy%2Bv75PQACZnok%3D",
    storeID: "23",
    gameID: "188229",
    salePrice: "17.58",
    normalPrice: "79.99",
    isOnSale: "1",
    savings: "78.022253",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608510583,
    dealRating: "10.0",
    thumb:
      "https://gamersgatep.imgix.net/0/2/7/9232da3e100abdd59cf045d63519512eb6613720.jpg?auto=format",
  },
  {
    internalName: "ONEPIECEWORLDSEEKERDELUXEEDITION",
    title: "ONE PIECE World Seeker Deluxe Edition",
    metacriticLink: null,
    dealID: "IlslsB6jzX5j8mU8JSHse3u1e2o7lT378z2aA9nryMg%3D",
    storeID: "23",
    gameID: "198716",
    salePrice: "19.32",
    normalPrice: "89.99",
    isOnSale: "1",
    savings: "78.530948",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608510600,
    dealRating: "10.0",
    thumb:
      "https://images.greenmangaming.com/2b5c492879d94ed89ba14193424a1ecf/a6c8f36e02f14d8c966334eedbc70109.jpg",
  },
  {
    internalName: "XCOM2COLLECTION",
    title: "XCOM 2 Collection",
    metacriticLink: null,
    dealID: "jQnBuRGiXWbFBbzBHGq%2BoQJNUef1QxqYV295afe1ipA%3D",
    storeID: "23",
    gameID: "177716",
    salePrice: "20.98",
    normalPrice: "99.99",
    isOnSale: "1",
    savings: "79.017902",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608510614,
    dealRating: "9.9",
    thumb:
      "https://gamersgatep.imgix.net/7/8/4/4f213b4138329288c5692c358dbcccc01b3f9487.jpg?auto=format",
  },
  {
    internalName: "ASSASSINSCREEDODYSSEYDELUXEEDITION",
    title: "Assassin's Creed Odyssey - Deluxe Edition",
    metacriticLink: null,
    dealID: "tKxiEMVHYAwJdAVZgHSl2o%2FENRc8WctQ2PQvbxPlZpY%3D",
    storeID: "2",
    gameID: "188229",
    salePrice: "18.20",
    normalPrice: "79.99",
    isOnSale: "1",
    savings: "77.247156",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608522823,
    dealRating: "9.9",
    thumb:
      "https://gamersgatep.imgix.net/0/2/7/9232da3e100abdd59cf045d63519512eb6613720.jpg?auto=format",
  },
  {
    internalName: "STARLINKBATTLEFORATLASDELUXEEDITION",
    title: "Starlink: Battle for Atlas - Deluxe Edition",
    metacriticLink: null,
    dealID: "TW8yi8DW0ORne0ONlr%2Bz7bDZx4bhkuVzfKe0ciQEEfY%3D",
    storeID: "2",
    gameID: "200999",
    salePrice: "18.20",
    normalPrice: "79.99",
    isOnSale: "1",
    savings: "77.247156",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608526916,
    dealRating: "9.9",
    thumb:
      "https://gamersgatep.imgix.net/f/e/6/0faf480ba1b12ebf337cd80481fd459d234aa6ef.jpg?auto=format",
  },
  {
    internalName: "SOUTHPARKTHEFRACTUREDBUTWHOLEGOLDEDITION",
    title: "South Park: The Fractured but Whole Gold Edition",
    metacriticLink: null,
    dealID: "tCOUt36bxDOcmFi%2FZFjNzehPXGaIp3IBahKK6MWv0tE%3D",
    storeID: "23",
    gameID: "153797",
    salePrice: "19.78",
    normalPrice: "89.99",
    isOnSale: "1",
    savings: "78.019780",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608510603,
    dealRating: "9.9",
    thumb:
      "https://gamersgatep.imgix.net/0/5/e/2f099d21d616f5cc6a0f28afa0d1e666dfa5be50.jpg?auto=format",
  },
  {
    internalName: "SIDMEIERSCIVILIZATIONVIDIGITALDELUXEEDITION",
    title: "Sid Meiers Civilization VI Digital Deluxe Edition",
    metacriticLink: null,
    dealID: "lHIYUIHTcwdZcS%2BC9Cyz57v7Yufwx7w6NDWnd42TkNU%3D",
    storeID: "2",
    gameID: "154951",
    salePrice: "18.40",
    normalPrice: "79.99",
    isOnSale: "1",
    savings: "76.997125",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608526884,
    dealRating: "9.9",
    thumb:
      "https://gamersgatep.imgix.net/9/d/1/f67bbe63d1cba1a2a7ce4bc34c48bba5f4b541d9.jpg?auto=format",
  },
  {
    internalName: "BULBBOY",
    title: "Bulb Boy",
    metacriticLink: "/game/pc/bulb-boy",
    dealID: "ywri%2F3DHEljdCdZZsLqDs43fA7qpuw9LLU0ttrgUlSc%3D",
    storeID: "2",
    gameID: "146786",
    salePrice: "0.90",
    normalPrice: "8.99",
    isOnSale: "1",
    savings: "89.988877",
    metacriticScore: "84",
    steamRatingText: "Very Positive",
    steamRatingPercent: "89",
    steamRatingCount: "396",
    steamAppID: "390290",
    releaseDate: 1446076800,
    lastChange: 1608509915,
    dealRating: "9.9",
    thumb:
      "https://cdn.cloudflare.steamstatic.com/steam/apps/390290/capsule_sm_120.jpg?t=1560495748",
  },
  {
    internalName: "STRANGEBRIGADEDELUXEEDITION",
    title: "Strange Brigade - Deluxe Edition",
    metacriticLink: null,
    dealID: "l%2FccblARuguXrh2TryF9OeU%2B3APZNqIBsnR%2F7dzUFQI%3D",
    storeID: "3",
    gameID: "186386",
    salePrice: "13.60",
    normalPrice: "79.99",
    isOnSale: "1",
    savings: "82.997875",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608081729,
    dealRating: "9.8",
    thumb:
      "https://gamersgatep.imgix.net/2/c/3/3b5dcc82e9677ab461cde60f34c793f0f8d1f3c2.jpg?auto=format",
  },
  {
    internalName: "WATCHDOGS2GOLDEDITION",
    title: "Watch_Dogs 2 Gold Edition",
    metacriticLink: null,
    dealID: "K1cAnXAIwb50bwodJFsG3%2BKCn9iVGPS3mZqPhtaXXP0%3D",
    storeID: "3",
    gameID: "153679",
    salePrice: "15.84",
    normalPrice: "89.99",
    isOnSale: "1",
    savings: "82.398044",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608165843,
    dealRating: "9.8",
    thumb:
      "https://gamersgatep.imgix.net/f/1/0/12669512cefc57a3273f7e92959f71b4e060b01f.jpg?auto=format",
  },
  {
    internalName: "FARCRY5GOLDEDITION",
    title: "Far Cry 5 Gold Edition",
    metacriticLink: null,
    dealID: "vOuwU%2FhMPZN4mdwmHf6bhce%2Fme1p5slBPbAD2K%2BJ2E4%3D",
    storeID: "3",
    gameID: "169242",
    salePrice: "15.84",
    normalPrice: "89.99",
    isOnSale: "1",
    savings: "82.398044",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608165803,
    dealRating: "9.8",
    thumb:
      "https://gamersgatep.imgix.net/f/9/6/3b855d00073bc3cb91510918e36d4cb865ede69f.jpg?auto=format",
  },
  {
    internalName: "THECREW2GOLDEDITION",
    title: "The Crew 2 Gold Edition",
    metacriticLink: null,
    dealID: "vY4OD%2F6QG1opUAqVyFhg5HxkYnaT0ConAlciVZsug28%3D",
    storeID: "3",
    gameID: "172258",
    salePrice: "15.84",
    normalPrice: "89.99",
    isOnSale: "1",
    savings: "82.398044",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608165461,
    dealRating: "9.8",
    thumb:
      "https://gamersgatep.imgix.net/0/3/c/b734b944a496465c1418880b8b2bd024d3762c30.jpg?auto=format",
  },
  {
    internalName: "BIOSHOCKINFINITE",
    title: "BioShock Infinite",
    metacriticLink: "/game/pc/bioshock-infinite",
    dealID: "vb3EqB4KpKbSyV83DXQYAZCSBS60LaOMgLCXSt8pQxw%3D",
    storeID: "23",
    gameID: "93503",
    salePrice: "6.40",
    normalPrice: "29.99",
    isOnSale: "1",
    savings: "78.659553",
    metacriticScore: "94",
    steamRatingText: "Overwhelmingly Positive",
    steamRatingPercent: "95",
    steamRatingCount: "76737",
    steamAppID: "8870",
    releaseDate: 1364169600,
    lastChange: 1608510402,
    dealRating: "9.8",
    thumb:
      "https://cdn.cloudflare.steamstatic.com/steam/apps/8870/capsule_sm_120.jpg?t=1602794480",
  },
  {
    internalName: "SOUTHPARKTHEFRACTUREDBUTWHOLEGOLDEDITION",
    title: "South Park: The Fractured but Whole Gold Edition",
    metacriticLink: null,
    dealID: "%2BcNoKzVFvD5B7jaojal6aqKNpwsk7dQuJxD0cSjJ8T8%3D",
    storeID: "2",
    gameID: "153797",
    salePrice: "20.47",
    normalPrice: "89.99",
    isOnSale: "1",
    savings: "77.253028",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608526902,
    dealRating: "9.8",
    thumb:
      "https://gamersgatep.imgix.net/0/5/e/2f099d21d616f5cc6a0f28afa0d1e666dfa5be50.jpg?auto=format",
  },
  {
    internalName: "SIDMEIERSCIVILIZATIONVIDIGITALDELUXE",
    title: "Sid Meier's Civilization VI Digital Deluxe",
    metacriticLink: null,
    dealID: "Et4Rq4SEEoGiztiuJpgJhyhgX74R3Rn%2B1yg4FM1eWE0%3D",
    storeID: "27",
    gameID: "152593",
    salePrice: "18.99",
    normalPrice: "79.99",
    isOnSale: "1",
    savings: "76.259532",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608509967,
    dealRating: "9.8",
    thumb:
      "https://hb.imgix.net/640ede1922e9a5c640cb3a976405217e779f77bb.jpg?auto=compress,format&fit=crop&h=84&w=135&s=87a2198cb145ab07379e50516c66c8be",
  },
  {
    internalName: "TOMCLANCYSGHOSTRECONBREAKPOINTGOLDEDITION",
    title: "Tom Clancys Ghost Recon Breakpoint Gold Edition",
    metacriticLink: null,
    dealID: "NYl1Cb7A3o58wuI1BCVLjGS%2BmzcHn7AAdOExRr5qZ%2BU%3D",
    storeID: "23",
    gameID: "201292",
    salePrice: "21.98",
    normalPrice: "99.99",
    isOnSale: "1",
    savings: "78.017802",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608510623,
    dealRating: "9.8",
    thumb:
      "https://gamersgatep.imgix.net/9/9/f/713a92bf6576a4696adb6f3600adaa4caed0af99.jpg?auto=format",
  },
  {
    internalName: "ASSASSINSCREEDODYSSEYGOLDEDITION",
    title: "Assassins Creed Odyssey Gold Edition",
    metacriticLink: null,
    dealID: "Uq1DfXH63BYZGHioGNFKueiIeNrUHDRltCZOdqtPgno%3D",
    storeID: "23",
    gameID: "188216",
    salePrice: "21.98",
    normalPrice: "99.99",
    isOnSale: "1",
    savings: "78.017802",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608510622,
    dealRating: "9.8",
    thumb:
      "https://gamersgatep.imgix.net/2/f/0/d505922309162d012412780ee074e06b97c380f2.jpg?auto=format",
  },
  {
    internalName: "SNIPERELITE4DELUXEEDITION",
    title: "Sniper Elite 4 Deluxe Edition",
    metacriticLink: null,
    dealID: "zoRA2Z3C2hD1GFZbDzW%2BhJQwqnfmGj15CwvSX%2Fb8Utk%3D",
    storeID: "3",
    gameID: "158734",
    salePrice: "15.30",
    normalPrice: "89.99",
    isOnSale: "1",
    savings: "82.998111",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608081312,
    dealRating: "9.7",
    thumb:
      "https://gamersgatep.imgix.net/b/e/a/cd55209b76a7acde6704cd80d9739348e0a81aeb.jpg?auto=format",
  },
  {
    internalName: "ASSASSINSCREEDORIGINSGOLDEDITION",
    title: "Assassins Creed Origins Gold Edition",
    metacriticLink: null,
    dealID: "X5ZACAovQsKmK3PWA61gSjOKzG%2FtZIVXfXdvG%2FmufpE%3D",
    storeID: "3",
    gameID: "170045",
    salePrice: "17.60",
    normalPrice: "99.99",
    isOnSale: "1",
    savings: "82.398240",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608165867,
    dealRating: "9.7",
    thumb:
      "https://gamersgatep.imgix.net/2/3/c/2aeaefcbb2d1810fa0fae3ffa0eec9cbf4a46c32.jpg?auto=format",
  },
  {
    internalName: "FARCRYNEWDAWNCOMPLETEBUNDLE",
    title: "Far Cry New Dawn Complete Bundle",
    metacriticLink: null,
    dealID: "Br%2FzRC0uYWamO77o8Kj2mOJksxJSUpy2%2FPciTnOXEZk%3D",
    storeID: "3",
    gameID: "221822",
    salePrice: "17.60",
    normalPrice: "99.99",
    isOnSale: "1",
    savings: "82.398240",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608165384,
    dealRating: "9.7",
    thumb:
      "https://images.greenmangaming.com/3fb6c037bbc443f294190401869d8253/a60ab0fa061041bda671b6b879657666.jpg",
  },
  {
    internalName: "DARKSIDERSIIIDELUXEEDITION",
    title: "Darksiders III: Deluxe Edition",
    metacriticLink: null,
    dealID: "Ks0WrvibDWIXsO6crlD33uZzDZK8ooDZ6Mj4Kz8ayv8%3D",
    storeID: "23",
    gameID: "189374",
    salePrice: "16.37",
    normalPrice: "79.99",
    isOnSale: "1",
    savings: "79.534942",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608318045,
    dealRating: "9.7",
    thumb:
      "https://gamersgatep.imgix.net/d/f/1/84cdbfe823dff21d0aa13a6eccfa85ef191ae1fd.jpg?auto=format",
  },
  {
    internalName: "DARKSIDERSIIIDELUXEEDITION",
    title: "Darksiders III: Deluxe Edition",
    metacriticLink: null,
    dealID: "Li26CxxzTBzQk%2FehgK0snKH1rzTLZfj2IWnvDhd8%2BQ0%3D",
    storeID: "28",
    gameID: "189374",
    salePrice: "16.39",
    normalPrice: "79.99",
    isOnSale: "1",
    savings: "79.509939",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608303199,
    dealRating: "9.7",
    thumb:
      "https://gamersgatep.imgix.net/d/f/1/84cdbfe823dff21d0aa13a6eccfa85ef191ae1fd.jpg?auto=format",
  },
  {
    internalName: "PRINCEOFPERSIATHESANDSOFTIME",
    title: "Prince of Persia: The Sands of Time",
    metacriticLink: "/game/pc/prince-of-persia-the-sands-of-time",
    dealID: "kQ8v%2BWL%2BbZhoZ%2BXyxL3NOL6xZEAyAyWIzMcu94IQGUY%3D",
    storeID: "23",
    gameID: "278",
    salePrice: "1.74",
    normalPrice: "9.99",
    isOnSale: "1",
    savings: "82.582583",
    metacriticScore: "89",
    steamRatingText: "Very Positive",
    steamRatingPercent: "86",
    steamRatingCount: "1450",
    steamAppID: "13600",
    releaseDate: 1070323200,
    lastChange: 1608510322,
    dealRating: "9.7",
    thumb:
      "https://cdn.cloudflare.steamstatic.com/steam/apps/13600/capsule_sm_120.jpg?t=1447351278",
  },
  {
    internalName: "ASSASSINSCREEDODYSSEYGOLDEDITION",
    title: "Assassins Creed Odyssey Gold Edition",
    metacriticLink: null,
    dealID: "td22faqaLUTnpi9LRZNPEC82HHgYAFd2aZoliwE%2FThM%3D",
    storeID: "2",
    gameID: "188216",
    salePrice: "22.75",
    normalPrice: "99.99",
    isOnSale: "1",
    savings: "77.247725",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608522823,
    dealRating: "9.7",
    thumb:
      "https://gamersgatep.imgix.net/2/f/0/d505922309162d012412780ee074e06b97c380f2.jpg?auto=format",
  },
  {
    internalName: "TOMCLANCYSSPLINTERCELLCHAOSTHEORY",
    title: "Tom Clancy's Splinter Cell Chaos Theory",
    metacriticLink: "/game/pc/tom-clancys-splinter-cell-chaos-theory",
    dealID: "4GIfAKLRBeau4Q%2FXxfXDmyrBmSot%2FssgZIHiNdJlyPM%3D",
    storeID: "23",
    gameID: "224",
    salePrice: "2.18",
    normalPrice: "9.99",
    isOnSale: "1",
    savings: "78.178178",
    metacriticScore: "92",
    steamRatingText: "Very Positive",
    steamRatingPercent: "92",
    steamRatingCount: "2432",
    steamAppID: "13570",
    releaseDate: 1111968000,
    lastChange: 1608510331,
    dealRating: "9.7",
    thumb:
      "https://cdn.cloudflare.steamstatic.com/steam/apps/13570/capsule_sm_120.jpg?t=1472141802",
  },
  {
    internalName: "FORHONORCOMPLETEEDITION",
    title: "For Honor Complete Edition",
    metacriticLink: null,
    dealID: "27jfaPuAG4cJ3ArGlXlBqIlcMEvFfuhniI3mIpSaqc0%3D",
    storeID: "23",
    gameID: "196575",
    salePrice: "24.18",
    normalPrice: "109.99",
    isOnSale: "1",
    savings: "78.016183",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608510636,
    dealRating: "9.7",
    thumb:
      "https://gamersgatep.imgix.net/9/5/2/6a325417b834a82eb11e1653e8f05a320ecbc259.jpg?auto=format",
  },
  {
    internalName: "WATCHDOGS2GOLDEDITION",
    title: "Watch_Dogs 2 Gold Edition",
    metacriticLink: null,
    dealID: "flhAUrByjJHBE13o9X0CDF%2FBnyDmx8UsUsy8RfELCxM%3D",
    storeID: "11",
    gameID: "153679",
    salePrice: "17.99",
    normalPrice: "89.99",
    isOnSale: "1",
    savings: "80.008890",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608265609,
    dealRating: "9.7",
    thumb:
      "https://gamersgatep.imgix.net/f/1/0/12669512cefc57a3273f7e92959f71b4e060b01f.jpg?auto=format",
  },
  {
    internalName: "AGEOFWONDERSPLANETFALLPREMIUMEDITION",
    title: "Age of Wonders: Planetfall - Premium Edition",
    metacriticLink: null,
    dealID: "6UcJ%2Fl5CXUTO6otWStN7BroDM1TKpxha2bgFhky32as%3D",
    storeID: "30",
    gameID: "198743",
    salePrice: "13.49",
    normalPrice: "89.99",
    isOnSale: "1",
    savings: "85.009445",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1607954970,
    dealRating: "9.7",
    thumb:
      "https://images.greenmangaming.com/18f2c9baa6974a5a94c3e15bd6715e00/5bb62f4449924cbd8a5f705b4e696edc.jpg",
  },
  {
    internalName: "BIOSHOCKINFINITE",
    title: "BioShock Infinite",
    metacriticLink: "/game/pc/bioshock-infinite",
    dealID: "OVrkWmI7sl5RN61pxpA44euybrH826w%2FjvlV%2BYKc2oA%3D",
    storeID: "2",
    gameID: "93503",
    salePrice: "6.90",
    normalPrice: "29.99",
    isOnSale: "1",
    savings: "76.992331",
    metacriticScore: "94",
    steamRatingText: "Overwhelmingly Positive",
    steamRatingPercent: "95",
    steamRatingCount: "76737",
    steamAppID: "8870",
    releaseDate: 1364169600,
    lastChange: 1608522870,
    dealRating: "9.7",
    thumb:
      "https://cdn.cloudflare.steamstatic.com/steam/apps/8870/capsule_sm_120.jpg?t=1602794480",
  },
  {
    internalName: "HUE",
    title: "Hue",
    metacriticLink: "/game/pc/hue",
    dealID: "QiwJ0zmYpkOH31D4dNTU2jD%2BroHc73XoFBqSIWX9ihI%3D",
    storeID: "23",
    gameID: "157736",
    salePrice: "1.21",
    normalPrice: "14.99",
    isOnSale: "1",
    savings: "91.927952",
    metacriticScore: "79",
    steamRatingText: "Very Positive",
    steamRatingPercent: "93",
    steamRatingCount: "623",
    steamAppID: "383270",
    releaseDate: 1472515200,
    lastChange: 1608510316,
    dealRating: "9.7",
    thumb:
      "https://cdn.cloudflare.steamstatic.com/steam/apps/383270/capsule_sm_120.jpg?t=1591106893",
  },
  {
    internalName: "WEHAPPYFEWDIGITALDELUXEEDITION",
    title: "We Happy Few Digital Deluxe Edition",
    metacriticLink: null,
    dealID: "VIJju1%2FCqqBEhyfmpIqXYeolgCniLzrtC8TMiyM6%2BxQ%3D",
    storeID: "3",
    gameID: "191733",
    salePrice: "15.83",
    normalPrice: "87.97",
    isOnSale: "1",
    savings: "82.005229",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608081026,
    dealRating: "9.7",
    thumb:
      "https://images.greenmangaming.com/7ee2a5239e9545d393a4d20d67a4a2b3/b5124814eefe4505873aa2b99cdd9f5a.jpg",
  },
  {
    internalName: "PRINCEOFPERSIATHESANDSOFTIME",
    title: "Prince of Persia: The Sands of Time",
    metacriticLink: "/game/pc/prince-of-persia-the-sands-of-time",
    dealID: "51qDvlvN5ah2Zubbn2wvEA7zzoY0z4TpWtiZBvrvbUI%3D",
    storeID: "2",
    gameID: "278",
    salePrice: "1.82",
    normalPrice: "9.99",
    isOnSale: "1",
    savings: "81.781782",
    metacriticScore: "89",
    steamRatingText: "Very Positive",
    steamRatingPercent: "86",
    steamRatingCount: "1450",
    steamAppID: "13600",
    releaseDate: 1070323200,
    lastChange: 1608526829,
    dealRating: "9.6",
    thumb:
      "https://cdn.cloudflare.steamstatic.com/steam/apps/13600/capsule_sm_120.jpg?t=1447351278",
  },
  {
    internalName: "SIDMEIERSCIVILIZATIONVIDIGITALDELUXEEDITION",
    title: "Sid Meiers Civilization VI Digital Deluxe Edition",
    metacriticLink: null,
    dealID: "wfO%2BXC%2BTn6ojbhLe7toTIbdx%2BGR4X5z5Nj0CrANEoOI%3D",
    storeID: "3",
    gameID: "154951",
    salePrice: "17.20",
    normalPrice: "79.99",
    isOnSale: "1",
    savings: "78.497312",
    metacriticScore: "0",
    steamRatingText: null,
    steamRatingPercent: "0",
    steamRatingCount: "0",
    steamAppID: null,
    releaseDate: 0,
    lastChange: 1608252201,
    dealRating: "9.6",
    thumb:
      "https://gamersgatep.imgix.net/9/d/1/f67bbe63d1cba1a2a7ce4bc34c48bba5f4b541d9.jpg?auto=format",
  },
  {
    internalName: "HUE",
    title: "Hue",
    metacriticLink: "/game/pc/hue",
    dealID: "Y2HV1y4AYeTrjyZmp4iQ5M%2BwPkitKwoqw6c8CR7xAqU%3D",
    storeID: "2",
    gameID: "157736",
    salePrice: "1.30",
    normalPrice: "14.99",
    isOnSale: "1",
    savings: "91.327552",
    metacriticScore: "79",
    steamRatingText: "Very Positive",
    steamRatingPercent: "93",
    steamRatingCount: "623",
    steamAppID: "383270",
    releaseDate: 1472515200,
    lastChange: 1608523296,
    dealRating: "9.6",
    thumb:
      "https://cdn.cloudflare.steamstatic.com/steam/apps/383270/capsule_sm_120.jpg?t=1591106893",
  },
];

export default database;
